import { ImageAnnotator } from './annotator';
import { Shape, Polygon, Rectangle, Circle, Point, Ellipse, Dot } from './base/types';
import { useImageAnnotator } from './annotator/hook';
export { ImageAnnotator, Shape, Polygon, Rectangle, Circle, Point, Ellipse, Dot, useImageAnnotator }
